import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-input-error-message',
  template: `
    <div class="error-message-container">
      <pt-icon *ngIf="iconKey" [key]="iconKey"></pt-icon>
      <h2 *ngIf="title">{{title}}</h2>
      <p *ngIf="message">{{message}}</p>
    </div>
  `,
  styles: [`
  `]
})
export class InputErrorMessageComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() iconKey?: string;
}

